import { useEffect } from 'react';
import useAuthStore from '@store/useAuthStore';
import api from '@/api/api';

const AuthInitializer = () => {
  const updateUser = useAuthStore((s) => s.updateUser);
  const setUser = useAuthStore((s) => s.setUser);
  const logout = useAuthStore((s) => s.logout);

  useEffect(() => {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      updateUser(null);
      return;
    }

    api
      .get('/auth/me')
      .then((res) => {
        updateUser(res.data);
      })
      .catch(() => {
        updateUser(null);
      });
  }, [logout, updateUser, setUser]);

  return null;
};

export default AuthInitializer;
